<central-login-header [platform]="currentPlatform"></central-login-header>
<div class="content">
   <h3 class="form-title">{{'central-login.error.occurred' | translate }}</h3>
   <div class="alert alert-danger">
      {{ errorMessage }}
   </div>
   <div class="row mt-3">
      <div class="col-md-12">
         <button class="btn psd-variant w-100" type="submit" (click)="goToLogin()">{{'central-login.login' | translate }}</button>
      </div>
   </div>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform" ></central-login-background-slider>